import React, { useState } from 'react';
import { MessageCircle, Send, Bot, User } from 'lucide-react';
import { Card, CardContent } from '../../../components/ui/card';
import { Button } from '../../../components/ui/button';
import BackButton from '../../../components/admin/BackButton';

/**
 * BMP ASSISTANT - CHAT
 * Conversational AI interface
 */

const AssistantChat = () => {
  const [message, setMessage] = useState('');
  const [messages, setMessages] = useState([
    {
      role: 'assistant',
      content: 'Hello! I\'m your BMP Assistant. How can I help you manage your platform today?',
      timestamp: new Date().toISOString()
    }
  ]);

  const handleSend = () => {
    if (!message.trim()) return;

    // Add user message
    const userMessage = {
      role: 'user',
      content: message,
      timestamp: new Date().toISOString()
    };

    // Simulate assistant response
    const assistantMessage = {
      role: 'assistant',
      content: 'I\'m currently in development mode. Full AI capabilities will be available soon!',
      timestamp: new Date().toISOString()
    };

    setMessages([...messages, userMessage, assistantMessage]);
    setMessage('');
  };

  return (
    <div className="h-full flex flex-col">
      <BackButton />
      
      <div className="mb-6">
        <div className="flex items-center space-x-3">
          <div className="p-3 bg-[#00B4D8] bg-opacity-10 rounded-lg">
            <MessageCircle className="h-6 w-6 text-[#00B4D8]" />
          </div>
          <div>
            <h2 className="text-2xl font-bold text-[#2B2D42]">Chat with BMP Assistant</h2>
            <p className="text-sm text-[#6C757D]">Ask questions, get help, and automate tasks</p>
          </div>
        </div>
      </div>

      {/* Chat Container */}
      <Card className="flex-1 flex flex-col">
        <CardContent className="flex-1 flex flex-col p-0">
          {/* Messages */}
          <div className="flex-1 overflow-y-auto p-6 space-y-4">
            {messages.map((msg, index) => (
              <div
                key={index}
                className={`flex items-start space-x-3 ${
                  msg.role === 'user' ? 'flex-row-reverse space-x-reverse' : ''
                }`}
              >
                <div
                  className={`p-2 rounded-full ${
                    msg.role === 'user'
                      ? 'bg-[#00B4D8]'
                      : 'bg-gray-200'
                  }`}
                >
                  {msg.role === 'user' ? (
                    <User className="h-5 w-5 text-white" />
                  ) : (
                    <Bot className="h-5 w-5 text-[#2B2D42]" />
                  )}
                </div>
                <div
                  className={`max-w-md p-4 rounded-lg ${
                    msg.role === 'user'
                      ? 'bg-[#00B4D8] text-white'
                      : 'bg-gray-100 text-[#2B2D42]'
                  }`}
                >
                  <p className="text-sm">{msg.content}</p>
                  <p
                    className={`text-xs mt-2 ${
                      msg.role === 'user'
                        ? 'text-white opacity-70'
                        : 'text-gray-500'
                    }`}
                  >
                    {new Date(msg.timestamp).toLocaleTimeString()}
                  </p>
                </div>
              </div>
            ))}
          </div>

          {/* Input */}
          <div className="border-t border-gray-200 p-4">
            <div className="flex items-center space-x-3">
              <input
                type="text"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                onKeyPress={(e) => e.key === 'Enter' && handleSend()}
                placeholder="Type your message..."
                className="flex-1 px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#00B4D8] focus:border-transparent"
              />
              <Button
                onClick={handleSend}
                className="bg-[#00B4D8] hover:bg-[#0096B8]"
              >
                <Send className="h-4 w-4 mr-2" />
                Send
              </Button>
            </div>
          </div>
        </CardContent>
      </Card>

      {/* Info */}
      <Card className="mt-4 bg-blue-50 border-blue-200">
        <CardContent className="pt-4">
          <p className="text-sm text-[#6C757D]">
            💡 <strong>Coming Soon:</strong> Full AI capabilities with natural language understanding, 
            context awareness, and automated task execution.
          </p>
        </CardContent>
      </Card>
    </div>
  );
};

export default AssistantChat;